import React from "react";
import "./Topinfobar.css";

const Topinfobar = () => {
  return (
    <div className="top-info-bar">
      <div className="phone-section">
        <span className="phone-icon">✆</span>
        <span className="phone-label">For Help Call:</span>
        <span className="phone-number">
          <a  href="https://wa.me/919289440049?text=Hi%2C%20I%20want%20to%20know%20more%20about%20DocMaster%20services.">9289 44 00 49</a>
        </span>
      </div>
    </div>
  );
};

export default Topinfobar;
